/**
 * Background Control Group - Main Export File
 *
 * This module exports the BackgroundControl component along with its related types
 * and utilities for use throughout the Redfox Thank You plugin.
 *
 * @package RedfoxThankYou
 * @since 1.0.0
 */

// Import styles (webpack will handle this)
import './style.scss';

// Export the main component
export { BackgroundControl } from './component';

// Export the premium controls component
export { BackgroundPremiumControls } from './premium';

// Export TypeScript interfaces and types
export type {
	BackgroundAttributes,
	BackgroundControlProps,
	BackgroundEnabledControls,
	BackgroundValues,
	PatternOption,
	ResponsiveBreakpoint,
} from './types';

// Export constants
export {
	backgroundAttachmentOptions,
	backgroundPositionOptions,
	backgroundRepeatOptions,
	backgroundSizeOptions,
	blendModeOptions,
	breakpointLabels,
	DEFAULT_BACKGROUND_ATTRIBUTES,
	DEFAULT_ENABLED_CONTROLS as DEFAULT_BACKGROUND_CONTROLS,
	defaultBackgroundValues,
	patternOptions,
} from './constants';

// Export style functions
export { getBackgroundCSS } from './style';

// Export utility functions
export { hasAnyBackgroundValues } from './utils';
